<template>
  <div>
    <ContentHeader :material-nav="true" :show-back="false" />
    <div class="content-container">
      <ItemList @toTemplate="toTemplate" @toFavourite="toFavourite" :item-type="'menu'"/>
    </div>
  </div>
</template>

<script>
import ContentHeader from '../../components/content-header'
import ItemList from './components/item-list'

export default {
  name: 'MenuList',
  components: {
    ContentHeader,
    ItemList
  },
  data () {
    return {}
  },
  methods: {
    toTemplate () {
      this.$router.push({ name: 'menu-list-template' })
    },
    toFavourite () {
      this.$router.push({ name: 'menu-favourite' })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
